module.exports = __webpack_public_path__ + "static/media/c2.19d4bd6c.jpg";